import { API_ENDPOINTS } from "shared/constants";
import { IAddress, ICoordinate } from "shared/types";
import { APIService } from "shared/services";
import { build } from "shared/utils";

export class GeocodingService {
  static get = (address: IAddress): Promise<ICoordinate> =>
    new Promise(async (resolve, reject) => {
      try {
        const normalizedData = await APIService.post({
          path: API_ENDPOINTS.GEOCODING,
          data: address,
        });
        const data = build(normalizedData, "geocodingOutput");
        resolve(data[0]);
      } catch (error) {
        reject(error);
      }
    });
}
